import {  Tooltip } from '@roo/roo'
import React from 'react'
import { IRulePackage } from '../utils/types'
import { useTranslation } from '@sailor/i18n-web'

const AddressRuleRender = (props: {data: IRulePackage['deliveryAddressRule']}) => {
  const { t } = useTranslation()

  const { checkDeliveryAddress, deliveryAddressList } = props.data || {}
  if (!checkDeliveryAddress || !deliveryAddressList?.length) return t('e_pc_no_limit', '不限制')
  return (
    <Tooltip content={<ul style={{ paddingLeft: '12px' }}>{deliveryAddressList.map(item => <li style={{ listStyleType: 'disc' }}> {item.address} </li>)}</ul>}>
      <div >
        <div  style={{ whiteSpace: 'nowrap', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{deliveryAddressList[0].address}</div>
        {deliveryAddressList.length > 1 && <div>,...</div>}
      </div>
    </Tooltip>
  )
}
export default AddressRuleRender